"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeWriter = void 0;
var react_1 = __importStar(require("react"));
var TypeWriter = function (_a) {
    var _b = _a.content, content = _b === void 0 ? "" : _b, _c = _a.speed, speed = _c === void 0 ? 1000 : _c;
    var _d = (0, react_1.useState)(""), displayedContent = _d[0], setDisplayedContent = _d[1];
    var _e = (0, react_1.useState)(0), index = _e[0], setIndex = _e[1];
    (0, react_1.useEffect)(function () {
        /*Create a new setInterval and store its id*/
        var animKey = setInterval(function () {
            setIndex(function (index) {
                /*This setState function will set the index
                to index+1 if there is more content otherwise
                it will destory this animation*/
                if (index >= content.length - 1) {
                    clearInterval(animKey);
                    return index;
                }
                return index + 1;
            });
        }, speed);
    }, []);
    (0, react_1.useEffect)(function () {
        setDisplayedContent(function (displayedContent) { return displayedContent + content[index]; });
    }, [index]);
    return react_1.default.createElement("pre", { className: "type-writer" }, displayedContent);
};
exports.TypeWriter = TypeWriter;
